<template>
  <div class="app-searchbar">
    <v-btn
      v-if="enableMicroAppRelease"
      icon
      :class="{'hidden-xs-only' : hideForXs}"
      title="Search companies"
      :href="microAppSearch"
    >
      <v-icon>search</v-icon>
    </v-btn>
    <v-btn
      v-else-if="searchBtnVisible"
      icon
      :class="{'hidden-xs-only' : hideForXs}"
      title="Search companies"
      @click.stop="searchVisible = true"
    >
      <v-icon>search</v-icon>
    </v-btn>
    <form
      class="app-searchbar__form"
      @submit.prevent="searchProvider">
      <transition
        :css="false"
        @enter="enter"
        @leave="leave"
        @after-leave="afterLeave"
      >
        <v-combobox
          v-if="searchVisible"
          ref="search"
          v-model="selectedProvider"
          :loading="isSearchLoading"
          :filter="searchFilter"
          :items="suggestions"
          :search-input.sync="searchTerm"
          :append-icon="null"
          append-outer-icon="close"
          prepend-icon="search"
          item-text="value"
          item-value="value"
          single-line
          hide-details
          hide-no-data
          dark
          color="white"
          class="app-searchbar__input"
          label="Search for companies on doxo..."
          @keyup.enter="searchProvider"
          @click:prepend="searchProvider"
          @click:append-outer="hideSearch"
        >
          <v-list-tile-content
            slot="item"
            slot-scope="data" >
            {{ data.item.value }}
          </v-list-tile-content>
        </v-combobox>
      </transition>
    </form>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Velocity from 'velocity-animate'
  import providerSearchMixin from '@/mixins/provider-search'
  import siteUrls, { enableMicroApp } from '@/helpers/site_urls'

  export default {
    mixins: [providerSearchMixin],
    props: {
      hideForXs: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        searchBtnVisible: true
      }
    },
    computed: {
      ...mapState('layout', ['showSearchbar']),
      searchVisible: {
        get () {
          return this.showSearchbar
        },
        set (val) {
          // If there isn't enough room to expand the search, navigate to the search page
          if (window.innerWidth < 700) {
            window.location.assign('/search')
          } else {
            this.$store.dispatch('layout/setSearchbar', val)
          }
        }
      },
      enableMicroAppRelease () { return enableMicroApp },
      microAppSearch () { return siteUrls.microAppSearch }
    },
    watch: {
      searchVisible (val) {
        if (val) {
          this.$nextTick(() => {
            this.$refs.search.$refs.input.focus()
          })
        } else {
          this.selectedProvider = null
          this.suggestions = []
        }
      }
    },
    methods: {
      hideSearch () {
        this.searchVisible = false
      },
      enter (el, done) {
        this.searchBtnVisible = false
        // TODO (mikew): Make easing a global variable
        Velocity(el, { translateX: [0, '100%'] }, { easing: [0.25, 0.8, 0.25, 1], duration: 200, complete: done })
      },
      leave (el, done) {
        Velocity(el, { translateX: ['100%', 0] }, { easing: [0.25, 0.8, 0.25, 1], duration: 200, complete: done })
      },
      afterLeave () {
        this.searchBtnVisible = true
      }
    }
  }
</script>

<style lang="stylus">
  .app-searchbar
    &__form
      overflow: hidden
    &__input
      width: 400px
    // Ugly hack to prevent the default behavior of rotating the icon
    .input-group--select.input-group--focused.input-group--open .input-group__append-icon
      transform: none
</style>



// WEBPACK FOOTER //
// frontend/src/components/core/AppSearchbar.vue